import generateUrlParamsFromObject from './generate-url-params-from-object'
import { getLocationFilterParams } from '../models/LocationFilter'

const buildSearchParams = (eventType, locationFilter) => {
  const params = {}
  if (eventType) {
    params.eventType = eventType
  }
  // Exactly one of location / fylke, never both.
  Object.assign(params, getLocationFilterParams(locationFilter))
  return generateUrlParamsFromObject(params)
}

export default buildSearchParams
